import { CreateButton } from 'components/button/CreateButton';
import { DebouncedSearchInput } from 'components/data/DebouncedSearchInput';
import { DocumentTitle } from 'components/DocumentTitle';
import { TablePageLayout } from 'components/page/styled';
import { usePermissions } from 'contexts/PermissionsContext';
import { usePagedAssemblyApplicationTypeDataSource } from 'custom_hooks/data_hooks/data_source/assemblyApplicationTypesDataSource';
import { AssemblyTypeDetailsPage } from 'pages/Settings/AssemblyType/AssemblyTypeDetailsPage';
import { AssemblyTypesTable } from 'pages/Settings/AssemblyType/AssemblyTypesTable';
import { CreateAssemblyTypeModal } from 'pages/Settings/AssemblyType/CreateAssemblyTypeModal';
import { SearchCreateButtonContainer } from 'pages/Settings/shared/styled';
import { useEffect, useState } from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';

export function AssemblyTypesPage() {
    const { canEditAssemblyType: canCreateAssemblyType } = usePermissions();
    const { url } = useRouteMatch();

    const dataSource = usePagedAssemblyApplicationTypeDataSource({
        name: 'assembly-types-table',
        defaultFilter: {
            nameSearch: '',
        },
    });

    const { setFilter, reset, reloadPage } = dataSource;
    const [showCreateAssemblyTypeModal, setShowCreateAssemblyTypeModal] = useState(false);
    const [nameSearch, setNameSearch] = useState('');

    const onClose = (saved: boolean) => {
        setShowCreateAssemblyTypeModal(false);
        if (saved) {
            reset();
            reloadPage();
        }
    };

    useEffect(() => {
        setFilter((currentFilter) => ({
            ...currentFilter,
            nameSearch,
        }));
    }, [nameSearch, setFilter]);

    return (
        <>
            <DocumentTitle title="Assembly Type Settings" />
            <Switch>
                <Route
                    path={`${url}/:assemblyTypeId`}
                    render={({ match }) => (
                        <AssemblyTypeDetailsPage
                            assemblyTypeId={Number(match.params.assemblyTypeId)}
                        />
                    )}
                />
                {/* @ts-expect-error: type issue with older version of react-router-dom */}
                <Route default>
                    <TablePageLayout>
                        <SearchCreateButtonContainer>
                            <DebouncedSearchInput
                                placeholder="Search"
                                value={nameSearch}
                                onChange={setNameSearch}
                            />
                            {canCreateAssemblyType && (
                                <CreateButton
                                    onClick={() => setShowCreateAssemblyTypeModal(true)}
                                />
                            )}
                            {showCreateAssemblyTypeModal && (
                                <CreateAssemblyTypeModal onClose={onClose} />
                            )}
                        </SearchCreateButtonContainer>
                        <AssemblyTypesTable dataSource={dataSource} />
                    </TablePageLayout>
                </Route>
            </Switch>
        </>
    );
}
